import { loadStripe } from '@stripe/stripe-js';
import runtimeConfig from '../../../runtime-config';
export default runtimeConfig.REACT_APP_STRIPE_PK ? loadStripe(runtimeConfig.REACT_APP_STRIPE_PK) : Promise.resolve(null);
